import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./tile-header-text.html';
import styles from './tile-header-text-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            text: '@'
        },
        template: cssUtil.hashTemplate(template, styles)
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/HeaderText/tileHeaderText.js
// module id = 1170
// module chunks = 0